export function normalizeUploadUrl(url) {
  return typeof url === "string" ? url.replace(/^http:\/\//, "https://") : url;
}
